module.exports = __webpack_public_path__ + "img/highShotText1.320e6428.png";